import { MortgageDataItem } from "../Components/RateGraph/MortgageGraph";
import { FinansPortalen } from "../types/deal.types";

export const extractDealAndCreateDiplayName = (deal:FinansPortalen):MortgageDataItem => {
    let displayDeal = {
        name: `${deal.ProductName}`,
        interestRate: deal.Int_Nominal
    }
    return displayDeal;
}